import { useContext } from "react";
import { ModuleContext } from "../../contexts/moduleContext";

const useModuleContext = () => {
  const value = useContext(ModuleContext);
  return value;
};

export default useModuleContext;
